import { PaginatedResponse } from '@/utils/types';
import { MeasurementGroupStatus } from '../types';
import { AxiosResponse } from 'axios';
import { CompactProcessObject } from '@/routes/process-objects/list/types';

export type MeasurementGroup = {
	id: number;
	indirectProcessObjectId: number;
	latestMeasurementAt: string;
	name: string;
	status: MeasurementGroupStatus;
};

export type QueryMeasurementGroupsArgs = {
	limit: string;
	page: string;
	sortBy: string;
	sortDirection: string;
	search: string;
};

export type MeasurementGroupsResponse = PaginatedResponse<MeasurementGroup>;

export type MgLine = {
	pathId: number;
	pathName: string;
};

export type MgLoad = {
	loadId: number;
	shortName: string;
	loadName: string;
	loadCapacity: number;
	city: string;
	state: string;
};

export type MgPlant = {
	plantId: number;
	shortName: string;
	plantName: string;
	nameplateCapacity: number;
	city: string;
	state: string;
};

export type MeasurementGroupListLoaderResponse = {
	measurementGroupList: MeasurementGroupsResponse;
	minifiedProcessObjects: Promise<AxiosResponse<CompactProcessObject[]>>;
	mgLineList: Promise<AxiosResponse<MgLine[]>>;
	mgLoadList: Promise<AxiosResponse<MgLoad[]>>;
	mgPlantList: Promise<AxiosResponse<MgPlant[]>>;
};

export enum MeasurementGroupColumns {
	id = 'ID',
	indirectProcessObjectId = 'INDIRECT_PROCESS_OBJECT_ID',
	name = 'NAME',
	status = 'STATUS',
	latestMeasurementAt = 'LATEST_MEASUREMENT_AT'
}
